/////////////////////////////////////////////////////////////////////////////////////////////////////////
//FileName: catalog.js
//FileType: Javascript Source file
//Size : ?
//Author : Harun Durmuş
//Created On : 11.12.2020 14:51
//Last Modified On : ?
//Copy Rights : Oceannet
//Description : Catalog Main Component, Redirects From side-menu.js Are Met Here.
////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from "react";
import { Redirect } from "react-router";
import SideMenu from "./sideMenu/SideMenu";
import ManagementUnits from "./tableContext/managementUnits/Main";
import Measures from "./tableContext/measures/Main";
import Discipline from "./tableContext/discipline/Main";
import WorkPlans from "./tableContext/workPlans/Main";
import WorkOrders from "./tableContext/workOrders/Main";
import WorkResources from "./tableContext/workResources/Main";
import Area from "./tableContext/area/Main";
import Financial from "./tableContext/financial/Main";
import Users from "./tableContext/users/Main";
import NatureProtection from "./tableContext/natureProtection/Main";
import PlanningPattern from "./tableContext/planningPattern/Main";
import PlanningPeriod from "./tableContext/planningPeriod/Main";
import FolderManagement from "./modal/folderManagement";
import TreeLinkFolder from "./modal/treeLinkFolder";
import AddFolder from "./modal/addFolder";
import { msalAuth } from "../../api/msal/MsalAuthProvider";
import LastUsedTableFilter from "../common/componet-jsons/variable.json";
import SideMenuProcess from "../managementMaintenance/sideMenu/SideMenuProcess";
import SideMenuProcessErrorModal from "../managementMaintenance/sideMenu/SideMenuProcessErrorModal";
import SideMenuBottom from "../managementMaintenance/sideMenu/SideMenuBottom";

const Catalog = (props) => {
  let compont;
  var tab = props.location.componentName;

  const [user, setUser] = useState(null);

  /*useEffect(async () => {
    try {
      const accessTokenRequest = {
        scopes: ["user.read", "openid", "profile"],
      };
      var accessToken = null;
      try {
        accessToken = await msalAuth
          .acquireTokenSilent(accessTokenRequest)
          .then((response) => {
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          });
      } catch (error) {
        console.log("AquireTokenSilent failure");
        console.log(error);
        accessToken = await msalAuth
          .acquireTokenRedirect(accessTokenRequest)
          .then((response) => {
            // get access token from response
            // response.accessToken
            window.$catalog_management_units_token =
              response.idToken.rawIdToken;
          })
          .catch((err) => {
            // handle error
            console.log(err);
          });
      }

      if (window.$catalog_management_units_token) {
        var user = await msalAuth.getAccount();
        await setUser(user);
      } else {
      }
    } catch (err) {
      var error = {};
      if (typeof err === "string") {
        var errParts = err.split("|");
        error =
          errParts.length > 1
            ? { message: errParts[1], debug: errParts[0] }
            : { message: err };
      } else {
        error = {
          message: err.message,
          debug: JSON.stringify(err),
        };
      }
    }
  });*/

  if (
    props.history.location.pathname.split("/")[2] !=
    props.location.componentName
  ) {
    tab = props.history.location.pathname.split("/")[2];
  }
  var treekey;
  switch (tab) {
    case "management-units":
      compont = <ManagementUnits {...props} />;
      treekey = "beheereenheden";
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_management_units_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });

      break;
    case "measures":
      compont = <Measures {...props} />;
      treekey = "maatregelen";
      for (var key in window) {
        console.log(key + "=" + window[key]);
      }
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_measures_last_used_table_filter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });

      break;
    case "discipline":
      compont = <Discipline {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !== "window.$catalog_discipline_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "work-plans":
      compont = <WorkPlans {...props} user={user} />;
      treekey = "werkplannen";
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !== "window.$catalog_work_plans_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });

      break;
    case "work-orders":
      compont = <WorkOrders {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_work_orders_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "work-resources":
      compont = <WorkResources {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_work_resources_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "area":
      compont = <Area {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (filterModel.value !== "window.$catalog_area_lastUsedTableFilter") {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "financial":
      compont = <Financial {...props} />;
      treekey = "financial";
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !== "window.$catalog_budget_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "gebruikersbeheer":
      compont = <Users {...props} />;
      treekey = "gebruikersbeheer";
      LastUsedTableFilter.forEach((filterModel) => {
        if (filterModel.value !== "window.$catalog_users_lastUsedTableFilter") {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;
    case "planning-patroon":
      compont = <PlanningPattern {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_planning_pattern_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;

    case "planning-period":
      compont = <PlanningPeriod {...props} />;
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !==
          "window.$catalog_planning_period_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;

    case "nature-protection":
      compont = <NatureProtection {...props} />;
      treekey = "nature-protection";
      LastUsedTableFilter.forEach((filterModel) => {
        if (
          filterModel.value !== "window.$nature_protection_lastUsedTableFilter"
        ) {
          window[filterModel.value.replace("window.", "")] = [];
        }
      });
      break;

    default:
      return <Redirect to="/catalog/management-units" />;
  }

  return (
    <div className="mt-5">
      <div className="clearfix">
        <div className="float-left w-30" id="menu-left">
          <SideMenu menuName="catalog" tabName={tab} treekey={treekey} />
          <FolderManagement treekey={treekey} />
          {treekey && true && treekey !== "financial" && treekey !== "gebruikersbeheer" &&
          treekey !== "nature-protection" ? (
            <TreeLinkFolder
              treekey={treekey}
              menuName="catalog"
              tabName={tab}
              buttonId={tab + "-koppel-aan-folder"}
            />
          ) : null}
          <AddFolder treekey={treekey} />
        </div>
        <div className="float-left ml-5 w-70" id="content-mid">
          {compont}
        </div>
      </div>
    </div>
  );
};

export default Catalog;
